// eslint-disable-next-line
import * as React from 'react';
import { BpiSupplier } from '../../../entities/BpiEntities';

type Props = {
    label: string;
    values: BpiSupplier[];
}


// ------------------------------------------------------------------------------------------------
// component

class BpiDetailsTableSupplierDataRow extends React.Component<Props> {

    // --------------------------------------------------------------------------------------------
    // render

    public render() {
        return (
            <tr>
                <th> <p> {this.props.label} </p> </th>
                <td>
                    <div>
                        {this.props.values && this.props.values.map((supplier, index) => {

                            return <div className='bpi-product-details-supplier-info' key={index}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <th>Legal Name</th>
                                            <td>{supplier.legalName}</td>
                                        </tr>

                                        {supplier.tradingName ?
                                            <tr>
                                                <th>Trading Name</th>
                                                <td>{supplier.tradingName}</td>
                                            </tr> : null
                                        }

                                        {supplier.nzbn ?
                                            <tr>
                                                <th>NZBN</th>
                                                <td>{supplier.nzbn} </td>
                                            </tr> : null
                                        }

                                        <tr>
                                            <th>Address</th>
                                            <td>{supplier.address}</td>
                                        </tr>

                                        {supplier.website ?
                                            <tr>
                                                <th>Website</th>
                                                <td><a href={supplier.website}>{supplier.website}</a></td>
                                            </tr> : null
                                        }

                                        {supplier.email ?
                                            <tr>
                                                <th>Email</th>
                                                <td><a href={`mailto:${supplier.email}`}>{supplier.email}</a></td>
                                            </tr> : null
                                        }
                                    </tbody>
                                </table>
                            </div>
                        })}
                    </div>

                    {this.props.values && this.props.values.length > 0 &&
                        <div className='bpi-product-details-notes'>Note: Occasionally, we might source products from alternative suppliers.</div>
                    }

                </td>
            </tr>
        )
    }
};



export default BpiDetailsTableSupplierDataRow;